import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { captureError } from '@clatter/platform';

interface NgErrorMessageProps {
  message?: string | null;
  logError?: boolean;
}

const StyledMessage = styled.p`
  color: ${({ theme }) => theme.palette.error};
`;

export const NgErrorMessage: FC<NgErrorMessageProps> = ({ message, logError = false }) => {

  useEffect(() => {
    if (logError && message) {
      captureError(new Error(message), { component: 'NgErrorMessage', severity: 'warning', skipConsole: true });
    }
  }, [logError, message]);

  if (!message) {
    return null;
  }

  return <StyledMessage className="error error-message">{message}</StyledMessage>;
};
